module.exports = __webpack_public_path__ + "img/pijlkop-donker.3a3f7aae625a8398ab9cb8b0bede63a0.svg";